import React, { useState, useEffect, useReducer } from "react";
import { Alert, Button, Card, Table } from "react-bootstrap";
import axios from "../../../../../config/axios";
import { Link } from "react-router-dom";
import UpdateQuestionModal from "./UpdateQuestionModal";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import { listingReducer, listingInitialState } from "../../reducers/listingReducer";
import { toastNotification } from "../../../../../config/toastNotification";
import AddQuestionOptionModal from "./AddQuestionOptionModal";
import UpdateQuestionOptionModal from "./UpdateQuestionOptionModal";


const PollQuestionOptions = ({ question, loadData }) => {
  const [showAddOptionModal, setShowAddOptionModal] = useState(false);
  const [showUpdateQuestionOptionModal, setShowUpdateQuestionOptionModal] = useState(false);
  const { confirm } = useConfirm();
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );
  const [thisOption, setThisOption] = useState(false);


  const confirmAndDeleteOption = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to delete this option?`
    );

    if (isConfirmed) {
      try {
        listingDispatch({
          type: "BLOCK_REQUEST",
        });
        const res = await axios.delete(`poll-question-options/delete-option/${id}`);
        loadData();
        // listingDispatch({
        //     type: "DELETE_SUCCESS"
        // });
        toastNotification.addNotification({
          ...toastNotification,
          title: "Success!",
          message: `Question deleted successfully.`,
          type: "success",
        });
      } catch (error) {
        listingDispatch({
          type: "BLOCK_FAILURE",
          payload: error,
        });

        setTimeout(() => {
          listingDispatch({
            type: "REMOVE_ERROR",
          });
        }, 5000);
      }
    }
  };


  const editThisOption = (option) => {
    setThisOption(option)
    setShowUpdateQuestionOptionModal(true);
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex flex-column ms-1">
          <span className="m-0 text-bold memberName">Manage Option(s)</span>
        </div>
        <div className="d-flex flex-column ms-3 " >
          <Button
            variant="primary"
            size="xs"
            onClick={() => setShowAddOptionModal(true)}
          >
            + Add Option
          </Button>
        </div>
      </div>
      <div className="">
        {(question.options.length > 0) ? <>
          {question.options.map((option, index) => {
            return <div className="option d-flex align-items-center justify-content-between mb-1">

              <div className="d-flex m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing p-0">
                  <div className="ms-1 mb-1">
                    <span className="VotersCount" style={{
                      backgroundColor: '#a2231d',
                      padding: '5px 8px',
                      marginRight: 10,
                      borderTopRightRadius: 10,
                      borderEndStartRadius: 10,
                      color: '#fff'

                    }}>{option.favourSubmissionsCount}</span>
                    <span className="m-0  memberName">{option.option}</span>
                  </div>
                </div>
              </div>

              <div class="card-tools mb-0">
                <div className=" text-right me-xl-2  mt-1">
                  <span
                    onClick={() => editThisOption(option)}
                    className="btn btn-sm btn-outline-secondary me-1"
                    title="Update Item"
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </span>
                  <span
                    onClick={() => confirmAndDeleteOption(option._id)}
                    className="btn btn-sm btn-outline-secondary  "
                    title="Delete Item"
                  >
                    <i className="fas fa-trash"></i>
                  </span>
                </div>
              </div>

              <UpdateQuestionOptionModal
                show={showUpdateQuestionOptionModal}
                setShow={setShowUpdateQuestionOptionModal}
                option={thisOption}
                loadData={loadData}
              />
            </div>
          })}
        </> : <>
          <Alert variant="warning" className="m-0">
            No options.
          </Alert>
        </>}
      </div>

      <AddQuestionOptionModal
        show={showAddOptionModal}
        setShow={setShowAddOptionModal}
        questionId={question._id}
        loadData={loadData}
      />


    </>

  );
};

export default PollQuestionOptions;
